import React from 'react';

import { flagStyles } from '../settings';

const SvgSE = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4680px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgSE;
